import { useDepoimento } from '@/hooks/use-conteudo';
import { useRevelarAoRolar } from '@/hooks/use-revelar-ao-rolar';

/**
 * Depoimento de cliente.
 *
 * Portada de `legacy/static-site/index.html`, a seção sem `id` entre o processo
 * e o showroom — não está no menu, é uma pausa entre dois blocos claros.
 *
 * O protótipo põe o `<figcaption>` dentro de uma `<div>`, o que não é HTML
 * válido: `figcaption` só existe dentro de `figure`. Aqui o container é uma
 * `<figure>`, que é o elemento certo para citação com atribuição — mesmo
 * resultado visual, e a autoria passa a ficar ligada à citação para quem usa
 * leitor de tela.
 *
 * Sem texto, a seção não existe. É a saída para o cliente tirar do ar o
 * depoimento de demonstração enquanto não tiver um real — melhor nenhuma seção
 * do que um elogio que ninguém escreveu.
 */
export function DepoimentoSection() {
  const depoimento = useDepoimento();
  const { ref, visivel } = useRevelarAoRolar<HTMLElement>();

  if (depoimento.texto === '') return null;

  return (
    <section ref={ref} className="bg-brand-600 py-[clamp(64px,9vw,124px)] text-bone">
      <figure
        className={`mx-auto m-0 max-w-[980px] px-6 text-center transition-[opacity,transform] duration-[900ms] ease-plane motion-reduce:transition-none ${
          visivel ? 'translate-y-0 opacity-100' : 'translate-y-[26px] opacity-0'
        }`}
      >
        <svg
          viewBox="0 0 60 40"
          aria-hidden="true"
          className="mx-auto mb-7 h-auto w-[52px] fill-bone/30"
        >
          <path d="M0 40V22C0 9.8 7.6 1.4 20 0l2 6c-7 1.6-10.8 6-11 12h9v22zm34 0V22C34 9.8 41.6 1.4 54 0l2 6c-7 1.6-10.8 6-11 12h9v22z" />
        </svg>

        <blockquote className="m-0 mb-7 font-display text-[clamp(1.3rem,3vw,2.1rem)] leading-[1.34] font-light tracking-[-0.015em] text-balance italic">
          {depoimento.texto}
        </blockquote>

        <figcaption className="flex flex-col gap-[5px]">
          <strong className="text-[0.86rem] font-medium tracking-[0.1em]">
            {depoimento.autor}
          </strong>
          {depoimento.contexto !== '' && (
            <span className="text-[0.72rem] tracking-[0.1em] text-bone/60">
              {depoimento.contexto}
            </span>
          )}
        </figcaption>
      </figure>
    </section>
  );
}
